export default __webpack_public_path__ + "static/media/sidemenu_assessment.88b3093b.svg";